import {
    GET_REJECT_LIST_PROGRESS, GET_REJECT_LIST_SUCCESS, GET_REJECT_LIST_FAILURE,
    ADD_REJECT_PROGRESS, ADD_REJECT_SUCCESS, ADD_REJECT_FAILURE,
    EDIT_DELETE_REJECT_PROGRESS, EDIT_DELETE_REJECT_SUCCESS, EDIT_DELETE_REJECT_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    reject: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const reject_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REJECT_LIST_SUCCESS:
            return { ...state, reject: action.reject, loading: false };
        case GET_REJECT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_REJECT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_REJECT_PROGRESS:
            return { ...state, loading: true };
        case ADD_REJECT_SUCCESS:
            return { ...state, reject: [...state.reject, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_REJECT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to save the record, try again!' };
        case EDIT_DELETE_REJECT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_REJECT_SUCCESS:
            return {
                ...state,
                reject: state.reject.map((reject) =>
                reject._id === action.payload._id ? action.payload : reject
                ),
                message: action.payload.is_deleted === 1 ? 'Record deleted successfully!' : 'Record updated successfully!'
            };
        case EDIT_DELETE_REJECT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to update the record, try again!' };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default reject_reducer;